import Breadcrumb from "component/common/breadcrumb";
import { AutocompletePlace } from "component/common/PlacesAutocomplete";
import React, { useEffect, useState } from "react";
import { Gallery, Item } from "react-photoswipe-gallery";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  editSupportForum,
  getsupportForumDetail,
} from "reduxStore/action/supportForumAction";
import strings from "translate/language";
import {
  handleDetailResponse,
  isEmpty,
  seo,
  ValidateExtensionImge,
  ValidateExtensionVideo,
} from "utils/utils";
import VideoModel from "component/common/videoModel";

const EditSupportForum = () => {
  const navigate = useNavigate();
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const dispatch = useDispatch();
  const [formVaild, setFormVaild] = useState(null);
  const [videoDetails, setVideoDetails] = useState(null);
  const [form, setForm] = useState({});
  const [uploadFields, setUploadFields] = useState([{ uploadFile: "" }]);
  const [videoFileds, setVideoFileds] = useState([{ uploadFile: "" }]);
  const params = useParams();
  const { support_forum_id = "" } = params || {};

  const {
    response = {},
    detail = false,
    create = false,
  } = useSelector((state) => state.supportForum) || {};

  useEffect(() => {
    dispatch(getsupportForumDetail({ support_forum_id }));
  }, [support_forum_id]);

  const handleChange = (index, event) => {
    let data = [...uploadFields];
    data[index]["uploadFile"] = event.target.files;
    setUploadFields(data);
  };
  const addUploadFields = () => {
    let newUploadField = { uploadFile: "" };
    setUploadFields([...uploadFields, newUploadField]);
  };
  const removeFields = (index) => {
    let data = [...uploadFields];
    data.splice(index, 1);
    setUploadFields(data);
  };
  const supportForumhandleChange = (index, event) => {
    let data = [...videoFileds];
    data[index]["uploadFile"] = event.target.files;
    setVideoFileds(data);
  };
  const addSupportForumFields = () => {
    let newPropertyField = { uploadFile: "" };
    setVideoFileds([...videoFileds, newPropertyField]);
  };
  const removeSupportForumFields = (index) => {
    let data = [...videoFileds];
    data.splice(index, 1);
    setVideoFileds(data);
  };
  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
  };
  const handleInputArea = (e) => {
    const nextFormState = {
      ...form,
      location: e,
      latitude: "",
      longitude: "",
    };
    setForm(nextFormState);
  };
  const onSelect = (latLng, location) => {
    const nextFormState = {
      ...form,
      location: location,
      latitude: latLng.lat,
      longitude: latLng.lng,
    };
    setForm(nextFormState);
  };

  useEffect(() => {
    if (detail === true) {
      if (response?.status === 200) {
        const result = handleDetailResponse(response.data);
        setForm({
          ...result,
          support_forum_id: result._id,
          title: result?.title,
          description: result.description,
          location: result.location,
          longitude: result.longitude,
          latitude: result.latitude,
        });
      }
    } else {
      if (create === true) {
        if (response?.status === 200) {
          setForm({});
          navigatpage("/supportforum");
        }
      }
    }
  }, [response]);

  const handleEdit = () => {
    if (!handleValid()) {
      const formData = new FormData();
      formData.append("support_forum_id", form.support_forum_id);
      formData.append("title", form?.title);
      formData.append("description", form.description);
      formData.append("location", form.location);
      formData.append("longitude", form.longitude);
      formData.append("latitude", form.latitude);
      form.images = uploadFields.map((i) => i.uploadFile);
      form.videos = videoFileds.map((i) => i.uploadFile);
      [...form.images].forEach((file) => {
        formData.append("images", file[0]);
      });
      [...form.videos].forEach((file) => {
        formData.append("videos", file[0]);
      });

      dispatch(editSupportForum(formData));
    }
  };

  const handleValid = () => {
    let err = {};
    let formError = false;
    if (!form.title) {
      formError = true;
      err["title"] = strings.titleErr;
    }
    if (!form.location) {
      formError = true;
      err["location"] = strings.locationerr;
    } else if (!form.longitude) {
      formError = true;
      err["location"] = strings.validLctionErr;
    } else if (form.longitude === "undefined") {
      formError = true;
      err["location"] = strings.validLctionErr;
    }
    if (!form.description) {
      formError = true;
      err["description"] = strings.descErr;
    }

    let images = handleDetailResponse(uploadFields)?.validMedia;
    if (images) {
      formError = true;
      err["images"] = images;
    }
    let videos = handleDetailResponse(videoFileds)?.validMedia;
    if (videos) {
      formError = true;
      err["videos"] = videos;
    }

    setFormVaild(err);
    return formError;
  };
  useEffect(() => {
    seo({
      title: "Edit Support Forum",
      metaDescription: "Edit support forum details",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <VideoModel data={videoDetails} />
      <Breadcrumb
        title={strings.editsupportForum}
        url={"/supportforum"}
        parentListing={strings.supportForumList}
        titleactive={strings.editsupportforum}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.editSupportForum}</h5>
              </div>
              <form className="form theme-form">
                <div className="card-body">
                  <div className="row ">
                    <div className="col-md-8 ">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlFirstName">
                          {strings.title}{" "}
                          <span className="required-field"></span>
                        </label>
                        <input
                          className="form-control"
                          id="exampleFormControlFirstName"
                          type="text"
                          placeholder={strings.title}
                          autoComplete="off"
                          name="title"
                          value={form.title}
                          onChange={handleInputField}
                        />
                        {formVaild?.title && (
                          <span style={{ color: "red" }}>
                            {formVaild?.title}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlSelect9">
                          {strings.location}
                          <span className="required-field"></span>
                        </label>
                        <AutocompletePlace
                          placeholder={strings.location}
                          name="location"
                          value={form.location}
                          onChange={handleInputArea}
                          onSelect={onSelect}
                        />
                        {formVaild?.location && (
                          <span style={{ color: "red" }}>
                            {formVaild?.location}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName">
                          {strings.description}
                          <span className="required-field"></span>
                        </label>
                        <textarea
                          className="form-control"
                          id=""
                          cols="74"
                          rows="5"
                          name="description"
                          placeholder={strings.description}
                          value={form.description}
                          onChange={handleInputField}
                          autoComplete="off"
                        ></textarea>
                        {formVaild?.description && (
                          <span style={{ color: "red" }}>
                            {formVaild?.description}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row align-items-center">
                    <div className="col">
                      <label htmlFor="exampleFormControlSelect9">
                        {strings.images}
                      </label>
                      <div className="row">
                        {form?.support_forum_content &&
                          form?.support_forum_content.length > 0 ? (
                          <>
                            {form?.support_forum_content.filter(
                              (item) => item.content_type === "image"
                            ).length > 0 && (
                                <div className=" col-md-11">
                                  <div className="row">
                                    {form?.support_forum_content
                                      ? form?.support_forum_content?.map(
                                        (item, index) =>
                                          item.content_type === "image" && (
                                            <Gallery
                                              key={index}
                                              withDownloadButton
                                            >
                                              <Item
                                                original={
                                                  form?.base_url + item.content
                                                }
                                                thumbnail={
                                                  form?.base_url + item.content
                                                }
                                                width="1024"
                                                height="768"
                                              >
                                                {({ ref, open }) => (
                                                  <figure
                                                    className="col-md-1"
                                                    itemProp="associatedMedia"
                                                    itemScope=""
                                                  >
                                                    <div
                                                      ref={ref}
                                                      onClick={open}
                                                      style={{
                                                        backgroundImage: `url(${form?.base_url}${item.content})`,
                                                        width: 48,
                                                        height: 42,
                                                        cursor: "pointer",
                                                        position: "relative",
                                                        backgroundSize: "cover",
                                                        backgroundPosition:
                                                          "50%",
                                                        backgroundRepeat:
                                                          "no-repeat",
                                                        border:
                                                          "1px solid black",
                                                      }}
                                                    ></div>
                                                    {/* 
                                                    <div className="removesupport_image_icon">
                                                      <i
                                                        className="fa fa-times text-danger"
                                                        aria-hidden="true"
                                                        data-toggle="modal"
                                                        data-original-title="test"
                                                        data-target="#exampleModal1"
                                                      ></i>
                                                    </div> */}
                                                  </figure>
                                                )}
                                              </Item>
                                            </Gallery>
                                          )
                                      )
                                      : null}
                                  </div>
                                  <hr />
                                </div>
                              )}
                          </>
                        ) : null}
                      </div>
                      <div className="row mb-3">
                        {uploadFields &&
                          uploadFields.map((form, index) => {
                            return (
                              <div className="col-sm-11 row" key={index}>
                                <div className="col-sm-9 mt-1">
                                  <input
                                    className="form-control"
                                    type="file"
                                    name="file"
                                    accept="image/*"
                                    onChange={(event) => {
                                      const validFile = ValidateExtensionImge(
                                        event.target
                                      );
                                      let data = [...uploadFields];
                                      if (validFile === true) {
                                        data[index]["uploadFile"] =
                                          event.target.files;
                                        data[index]["validMedia"] = null;

                                        setUploadFields(data);
                                        setFormVaild({
                                          ...formVaild,
                                          images: null,
                                        });
                                      } else {
                                        data[index]["uploadFile"] = "";
                                        data[index]["validMedia"] = validFile;
                                        setFormVaild({
                                          ...formVaild,
                                          images: null,
                                        });
                                        setUploadFields(data);
                                      }
                                    }}
                                  />
                                  {form.validMedia &&
                                    String(form.uploadFile) === "" && (
                                      <span style={{ color: "red" }}>
                                        {form.validMedia}
                                      </span>
                                    )}
                                </div>
                                {index != 0 && (
                                  <div className="col-sm-1 mt-1">
                                    <button
                                      style={{ marginTop: "2px" }}
                                      className="btn btn-danger"
                                      type="button"
                                      onClick={() => removeFields(index)}
                                    >
                                      -
                                    </button>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        <div className="col-sm-1">
                          <button
                            style={{ marginTop: "9px" }}
                            className=" btn btn-success"
                            type="button"
                            onClick={addUploadFields}
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row align-items-center">
                    <div className="col">
                      <label htmlFor="exampleFormControlSelect9">
                        {strings.videos}
                      </label>
                      <div className="row">
                        {form?.support_forum_content &&
                          form?.support_forum_content.length > 0 ? (
                          <>
                            {form?.support_forum_content &&
                              form?.support_forum_content.filter(
                                (item) => item.content_type === "video"
                              ).length > 0 && (
                                <div className=" col-md-12 align-items-center">
                                  <div className="row">
                                    {form?.support_forum_content
                                      .filter(
                                        (item) => item.content_type === "video"
                                      )
                                      .map((item, i) => (
                                        <div key={i} className="col-md-1">
                                          <img
                                            src={
                                              form?.base_url +
                                              item.video_thumbnail
                                            }
                                            className="img-thumbnail"
                                            style={{
                                              position: "relative",
                                              width: 70,
                                              height: 50,
                                              backgroundPosition: "50%",
                                              backgroundRepeat: "no-repeat",
                                            }}
                                          />
                                          <i
                                            className="fa fa-play theme-fa-icon"
                                            style={{
                                              position: "absolute",
                                              left: 34,
                                              top: "18px",
                                              cursor: "pointer",
                                              color: "#fff",
                                              fontSize: "14px",
                                            }}
                                            data-toggle="modal"
                                            data-original-title="test"
                                            data-target="#exampleModal"
                                            onClick={() => {
                                              item.base_url = form.base_url;
                                              item.document = item.content;
                                              setVideoDetails(item);
                                            }}
                                          ></i>
                                          {/* <div className="removesupport_video_icon">
                                            <i
                                              className="fa fa-times text-danger"
                                              aria-hidden="true"
                                              data-toggle="modal"
                                              data-original-title="test"
                                              data-target="#exampleModal1"
                                            ></i>
                                          </div> */}
                                        </div>

                                        /* ---------------- */
                                      ))}
                                  </div>
                                  <hr />
                                </div>
                              )}
                          </>
                        ) : null}
                      </div>
                      <div className="row mb-3">
                        {videoFileds &&
                          videoFileds.map((form, index) => {
                            return (
                              <div className="col-sm-11 row" key={index}>
                                <div className="col-sm-9 mt-1">
                                  <input
                                    className="form-control"
                                    id="exampleFormControlFirstName"
                                    type="file"
                                    name="file"
                                    accept="video/*"
                                    onChange={(event) => {
                                      const validFile = ValidateExtensionVideo(
                                        event.target
                                      );
                                      let data = [...videoFileds];
                                      if (validFile === true) {
                                        data[index]["uploadFile"] =
                                          event.target.files;
                                        data[index]["validMedia"] = null;

                                        setVideoFileds(data);
                                        setFormVaild({
                                          ...formVaild,
                                          videos: null,
                                        });
                                      } else {
                                        data[index]["uploadFile"] = "";
                                        data[index]["validMedia"] = validFile;
                                        setFormVaild({
                                          ...formVaild,
                                          videos: null,
                                        });
                                        setVideoFileds(data);
                                      }
                                    }}
                                  />
                                  {form.validMedia &&
                                    String(form.uploadFile) === "" && (
                                      <span style={{ color: "red" }}>
                                        {form.validMedia}
                                      </span>
                                    )}
                                </div>
                                {index != 0 && (
                                  <div className="col-sm-1 mt-1">
                                    <button
                                      style={{ marginTop: "2px" }}
                                      className="btn btn-danger"
                                      type="button"
                                      onClick={() =>
                                        removeSupportForumFields(index)
                                      }
                                    >
                                      -
                                    </button>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        <div className="col-sm-1">
                          <button
                            style={{ marginTop: "8px" }}
                            className="btn btn-success"
                            type="button"
                            onClick={addSupportForumFields}
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 d-flex justify-content-end">
                    <div className="card-footer">
                      <button
                        className="btn btn-color"
                        type="button"
                        onClick={() => handleEdit()}
                      >
                        {strings.update}
                      </button>
                    </div>
                  </div>
                  {!isEmpty(formVaild) && (
                    <div className="col-md-12 float-right">
                      <span
                        style={{
                          color: "red",
                          float: "right",
                          // padding: "5px 15px 25px 5px",
                        }}
                      >
                        {strings.fieldRequired}
                      </span>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EditSupportForum;
